import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';


export function getContableCuentaListSuccess(contablecuenta) {
  return {type: types.LOAD_CONTABLECUENTA_LIST_SUCCESS, contablecuenta};
}



export function getContableCuentaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableCuentaApi.getContableCuentaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(contablecuenta => {                  
                  dispatch(getContableCuentaListSuccess(contablecuenta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getContableCuentaSuccess(catalogo) {
  return {type: types.LOAD_CONTABLECUENTA_SUCCESS, catalogo};
}

export function getContableCuenta(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ContableCuentaApi.getContableCuenta(id, token).then(contablecuenta => {   
        dispatch(getContableCuentaSuccess(contablecuenta));
        return contablecuenta;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(contablecuenta) {
  return {type: types.SAVE_CONTABLECUENTA_SUCCESS, contablecuenta};
}


export function save(contablecuenta, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ContableCuentaApi.save(contablecuenta, token).then(contablecuentaGuardado => {   
    dispatch(saveSuccess(contablecuentaGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getContableCuentaComboSuccess(datos) {
  return {type: types.GET_CONTABLECUENTAS_COMBO_SUCCESS, datos};
}

export function getContableCuentaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ContableCuentaApi.getContableCuentaCombo(token).then(datos => {   
        
      dispatch(getContableCuentaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(contablecuenta) {
  return {type: types.BORRAR_CONTABLECUENTA_SUCCESS, contablecuenta};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableCuentaApi.borrar(id, token ).then(contablecuenta => {
               
                  dispatch(borrarSuccess(contablecuenta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(contablecuenta) {
  return {type: types.ACTIVAR_CONTABLECUENTA_SUCCESS, contablecuenta};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableCuentaApi.activar(id, token).then(contablecuenta => {
               
                  dispatch(activarSuccess(contablecuenta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CONTABLECUENTA, filtro};
}



